import { useEffect, type FC } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useGetEnrollmentHYCSHomeData, useSubmitEnrollmentHYCSHomeData } from '@egw/api'
// import { GenericError } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { Logger } from '@egw/logger'
import { EnrollmentHYCSLayout } from '@egw/layouts'
import { enrollmentCookieService } from '@egw/enrollment-cookie'
import { riskService } from '@egw/risk-service'
import { useValidateRoute } from '../../../hooks/navigation/validate-route'

const log = new Logger('Enrollment - HYCS - Home')

export const HomePage: FC = () => {
  const { t } = useTranslation('features-enrollment')

  // Reset enrollment session before initiating application
  useEffect(() => {
    void enrollmentCookieService.resetSession()
    void riskService.updateFlow('enrollment')
  }, [])

  const { data, isLoading } = useGetEnrollmentHYCSHomeData({
    initiateApplication: true,
  })

  // Protect route
  useValidateRoute(data?.path)

  return (
    <EnrollmentHYCSLayout>
      <div className="egw-container-enroll-hycs h-full flex flex-col relative md:justify-center justify-start items-start">
        {/* Loading initial data to make sure the user has access to this screen and retreive data based on user enrollment application */}
        {isLoading ? (
          <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
            <Skeleton count={1} height="100px" className="mb-10" />
            <Skeleton count={5} height="50px" />
          </SkeletonTheme>
        ) : null}
        {/* This error handles the case when the initial data is not loaded, for example network error */}
        {/* {error && !isLoading ? (
          <div className="flex-1 flex flex-col justify-start md:justify-center">
            <GenericError errorMessage={t('common.generic_error')} />
          </div>
        ) : null} */}
      </div>
    </EnrollmentHYCSLayout>
  )
}
